import { Reveal } from "@/components/Reveal";

const STEPS = [
  {
    n: "01",
    title: "Scegli giorno e orario",
    text: "Compila la prenotazione: nome, telefono, data e orario. Il 20% di sconto sul menù alla carta è incluso, fino a posti limitati.",
  },
  {
    n: "02",
    title: "Ricevi il biglietto",
    text: "Ti arriva per email il biglietto PRENOTAZIONE 20% con il tuo codice personale. Salvalo sul telefono.",
  },
  {
    n: "03",
    title: "Vieni a mangiare",
    text: "Mostra il codice al personale al tuo arrivo: il 20% di sconto sul menù alla carta è tuo.",
  },
];

const SUSHI_IMG = "/assets/baianeira/sushi-platter.jpeg";
const TOAST_VIDEO = "/assets/baianeira/toast-clip.mp4";

export const Steps = () => (
  <section id="come-funziona" data-testid="steps-section" className="relative bg-[#050505] py-20 md:py-32">
    <div className="mx-auto max-w-6xl px-5 md:px-8">
      <Reveal>
        <p className="text-[10px] font-semibold tracking-[0.4em] text-[#D4AF37] md:text-xs">
          COME FUNZIONA
        </p>
        <h2 className="mt-4 max-w-xl font-display text-3xl leading-tight text-[#F5F2E9] md:text-5xl">
          Dal social al tavolo, <em className="not-italic text-[#D4AF37]">in tre passi</em>
        </h2>
      </Reveal>

      <div className="mt-12 grid gap-10 md:mt-16 md:grid-cols-3 md:gap-8">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div className="border-t border-[#D4AF37]/25 pt-6">
              <span className="text-outline-gold font-display text-5xl md:text-6xl">{s.n}</span>
              <h3 className="mt-4 font-display text-xl text-[#F5F2E9] md:text-2xl">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#A3A3A3]">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1} className="mt-20 md:mt-32">
        <div className="grid items-center gap-12 md:grid-cols-2 md:gap-16">
          <div className="relative pb-12 pr-8 md:pb-16 md:pr-16">
            <div className="absolute -left-3 -top-3 hidden h-full w-full border border-[#D4AF37]/40 md:block" />
            <img
              src={SUSHI_IMG}
              alt="Nigiri di salmone e tonno Baianeira"
              className="relative aspect-[4/5] w-full object-cover"
            />
            <video
              data-testid="toast-clip-video"
              src={TOAST_VIDEO}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              className="gold-glow absolute bottom-0 right-0 w-1/2 border border-[#D4AF37]/60 object-cover aspect-square"
            />
          </div>
          <div>
            <p className="text-[10px] font-semibold tracking-[0.4em] text-[#D4AF37] md:text-xs">
              L'ESPERIENZA
            </p>
            <blockquote className="mt-6 font-display text-2xl italic leading-snug text-[#F5F2E9] md:text-4xl">
              «Il tuo prossimo viaggio nel gusto inizia qui.»
            </blockquote>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-[#A3A3A3]">
              Baianeira Sushi Fusion ti aspetta a Roma, in zona Cinecittà —
              Metro Subaugusta. Una fusione elegante tra la tradizione del sushi
              e sapori tropicali, da scoprire con il tuo coupon esclusivo.
            </p>
            <p className="mt-8 text-[10px] tracking-[0.3em] text-[#D4AF37]/70">
              BAIANEIRA SUSHI FUSION · ROMA
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Steps;
